export default {"src":"/_next/static/media/avatarPlus5_24.7763d43c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};